import {
  EProductBundleActionTypes,
  type EProductBundleActions,
  type IProduct,
  type IProductBundleState,
} from './productBundle.interfaces';

export const productBundleReducer = (
  state: IProductBundleState,
  action: EProductBundleActions,
): IProductBundleState => {
  const { type, payload } = action;

  switch (type) {
    case EProductBundleActionTypes.FILL_LIST: {
      return { ...state, productList: payload as Array<IProduct> };
    }

    case EProductBundleActionTypes.ADD_PRODUCT: {
      const productList = state.productList.map((product) => {
        if (product.modelId === (payload as IProduct['modelId'])) {
          return { ...product, isInBundle: true };
        }
        return product;
      });

      return { ...state, productList };
    }

    case EProductBundleActionTypes.REMOVE_PRODUCT: {
      const productList = state.productList.map((product) => {
        if (product.modelId === (payload as IProduct['modelId'])) {
          return { ...product, isInBundle: false };
        }
        return product;
      });

      return { ...state, productList };
    }

    case EProductBundleActionTypes.SET_IS_LOADING: {
      return { ...state, state: { isFetching: payload as boolean } };
    }

    default:
      return state;
  }
};
